export const navigationSelectorTypesEnum = {
    nonFiltered: 0,
    professorFiltered: 1,
    moderatorReworks: 2,
};